export const DELETE_IMAGE_CLICK_TOPIC = 'delete_image_click_topic'
export const PRINCIPAL_IMAGE_CLICK_TOPIC = 'principal_image_click_topic'
export const IMAGE_CLICK_TOPIC = 'image_click_topic'
export const IMAGE_UPLOADED_TOPIC = 'image_uploaded_topic'
export const REPORT_EDITOR_CLOSE_ALL_TABS_TOPIC = 'close_section_topic'
export const REPORT_EDITOR_OPEN_ALL_TABS_TOPIC = 'open_section_topic'
export const MEDIA_ID_CHANGED_FROM_CACHE = 'id-changed-from-cache'
export const DISPLAY_ALERT_TOPIC = 'display-alert-topic'
export const CLOSE_ITEM_SCREEN_TOPIC = 'close-item-screen-topic'
export const DELETE_MODIFICATIONS_NOT_SYNCHRONIZED = 'delete_modifications_not_synchronized'
export const DELETE_NOT_SYNCHRONIZED_NEW_ITEM = 'delete_not_synchronized_new_item'
export const SAVE_CURRENT_ITEM_TOPIC = 'save_current_item_topic'
export const TOGGLE_MENU_TOPIC = 'toggle_menu_topic';
export const MEDIA_END_LOADING_TOPIC = 'media_end_loading'
export const ASK_FOR_MISSING_LOCATION = 'ask_for_missing_location'
export const STOP_ASKING_FOR_MISSING_LOCATION_TOPIC = 'stop_asking_for_missing_location'
export const FORCE_UPDATE_SERVICE_WORKER_TOPIC = 'force_update_sw_topic'
export const ITEM_CREATION_IMG_POPUP_ADD_MEDIA = "item_creation_img_popup_add_media"
export const FREE_MEDIA_CACHE_TOPIC = 'free_media_cache'